module.exports = __webpack_public_path__ + "static/media/biometric_authentication.82e15c58.png";